var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","flat":""},on:{"click":function($event){_vm.goToEditPage()}}},[_c('v-icon',{staticClass:"my-auto",attrs:{"color":"primary","small":""}},[_vm._v("fas fa-edit")])],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e94f64ac","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ListOptionsComponent.vue
// module id = null
// module chunks = 